var map = {
	"./": 415,
	"./ca": 1119,
	"./ca.js": 1119,
	"./cn": 1120,
	"./cn.js": 1120,
	"./en": 605,
	"./en.js": 605,
	"./es": 1121,
	"./es.js": 1121,
	"./fi": 1122,
	"./fi.js": 1122,
	"./formatted-message": 606,
	"./formatted-message.js": 606,
	"./index": 415,
	"./index.js": 415,
	"./ja": 1123,
	"./ja.js": 1123,
	"./locales": 168,
	"./locales.js": 168,
	"./pt": 1124,
	"./pt.js": 1124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1997;